import React, { useRef, useState, useEffect } from 'react'
import { Tween } from 'react-gsap';
import img from '../asset/aa.png';

import Dinor from './Dinor';

const MotionTween = () => {

    const dinorRef = useRef(null);
    const dinorRef2 = useRef(null);

    const handleChangeEmoji = (e) => {
        /**
         * tween motion restart
         * useRef .current 를 통해 접근
         */

        dinorRef.current.tween.restart();
    }

    const handleChangeEmoji2 = () => {
        dinorRef2.current.tween.restart();
    }

    // get window innerWidth
    const winW = useState(window.innerWidth);


    // dinor rotate repeat
    const dinorRepeat = () => {
        setInterval(()=>{
            document.getElementById('dinor').classList.toggle('rotate-effect')
        },3000)
    }
    useEffect(() => {
        dinorRepeat();
    });


    useEffect(() => {
        console.log('1', winW[0]);
    },[]);


    return ( 
        <>
            <section>
                <h2>Tween</h2>

                <div>
                    <Tween
                        ref={dinorRef}
                        from={{ rotation: -180, scale: 0.2 }}
                        duration={.5}
                    >
                        <img src={img} alt=""/>
                    </Tween>    
                </div>

                <button onClick={handleChangeEmoji} type="button">restart</button>

                <div>
                    <Tween
                        ref={dinorRef2}
                        from={{ x: winW[0], scale: 0.5}}
                        duration={5}
                    >
                        <img src={img} alt=""/>
                    </Tween>   
                </div>
                <button onClick={handleChangeEmoji2} type="button">restart</button>

                <div>
                    <Tween
                        from={{ x: winW[0], scale: 0.5}}
                        duration={3}
                        repeat={-1}
                        yoyo={true}
                    >
                        <span className="dinor-elem">
                            <img id="dinor" src={img} alt=""/>
                        </span>
                    </Tween>   
                </div>

                <div>
                    <Tween
                        from={{ x: winW[0], scale: 0.5, opacity: 0}}
                        to={{ x: -130, scale: 1, opacity: 1}}
                        duration={5}
                        repeat={-1}
                        yoyo={false}
                    >
                        <img src={img} alt=""/>
                    </Tween>   
                </div>


                {/* Dinor 컴포넌트 */}
                <Dinor spd={.8} />

                <div>
                    <Tween
                        from={{ x: winW[0]}}
                        to={{ x: -130}}
                        duration={5}
                        repeat={-1}
                        yoyo={false}
                        >
                            <div>
                                <Dinor spd={.2} />  
                            </div>
                    </Tween>
                </div>

            </section>
        </>
     );
}
 
export default MotionTween;